import Vue from 'vue'

const apis = {
  QUERY_DATA_SELECTOR_OTHER_FORM: {
    url: '/xdap-app/formConfig/query/dataSelectorOtherForm',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_DATA_SELECTOR_COMPONENT: {
    url: '/xdap-app/formConfig/query/dataSelectorComponent',
    method: 'get',
    disableSuccessMsg: true
  }
}

const loadQueryDataSelectorOtherForm = (menuId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DATA_SELECTOR_OTHER_FORM,
      params: {
        menuId
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data.map((res) => {
                return {
                  label: res.menuName,
                  value: res.formId,
                  extra: res
                }
              })
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const loadQueryDataSelectorComponent = (formId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DATA_SELECTOR_COMPONENT,
      params: {
        formId
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data.map((res) => {
                return {
                  label: res.label,
                  value: res.uuid,
                  extra: res
                }
              })
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

export default {
  editorConfigType: 'LOV_CHOOSETYPE',
  componentName: 'FormConfigLovDataSelector',
  configProperty: 'dataSelector',
  extras: {
    otherFormConfig: {
      loadQueryDataSelectorOtherForm: loadQueryDataSelectorOtherForm,
      loadQueryDataSelectorComponent: loadQueryDataSelectorComponent
    }
  }
}
